import fp from 'lodash/fp';
import { createSelector } from 'reselect';

export const getLowStockItems = fp.get('inventory.reports.lowStockItems');

export const getAll = createSelector(getLowStockItems, fp.get('all'));

export const getIsFetching = createSelector(
  getLowStockItems,
  fp.get('fetching')
);
export const getIsFetched = createSelector(getLowStockItems, fp.get('fetched'));
export const getFetchingError = createSelector(
  getLowStockItems,
  fp.get('fetchingError')
);
